import React from 'react';

import { AccessibilityRole, StyleSheet } from 'react-native';

import { Box } from 'components/ui';

export const VisuallyHidden: React.FC<React.PropsWithChildren<{
  accessibilityLabel: string;
  role?: AccessibilityRole;
  testID?: string;
}>> = ({ accessibilityLabel, role, testID, children }) => (
  <Box
    accessibilityRole={role}
    accessibilityLabel={accessibilityLabel}
    testID={testID}
    style={styles.hidden}
  >
    {children}
  </Box>
);

const styles = StyleSheet.create({
  hidden: {
    display: 'none',
  },
});
